import createReducer from 'utils/createReducer';

const SET_FETCHING = 'shipper-order-detail/SET_FETCHING';
const SET_DATA = 'shipper-order-detail/SET_DATA';
const SET_ERROR = 'shipper-order-detail/SET_ERROR';

const SET_QUOTE_LOADING = 'shipper-order-detail/SET_QUOTE_LOADING';
const SET_QUOTE = 'shipper-order-detail/SET_QUOTE';
const SET_RESET_QUOTE = 'shipper-order-detail/SET_RESET_QUOTE';

// Initial State
const INIT_STATE = {
  data: null,
  fetching: true,
  opened: false,
  error: null,
  costQuote: {
    loading: false,
  },
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_FETCHING](state, payload) {
    return {
      ...state,
      fetching: payload,
    };
  },

  [SET_DATA](state, payload) {
    return {
      ...state,
      data: payload,
    };
  },
  [SET_ERROR](state, payload) {
    return {
      ...state,
      error: payload,
    };
  },
  [SET_QUOTE_LOADING](state, payload) {
    return {
      ...state,
      costQuote: {
        ...state.costQuote,
        loading: payload,
      },
    };
  },
  [SET_QUOTE](state, payload) {
    return {
      ...state,
      costQuote: {
        ...state.costQuote,
        ...payload,
      },
    };
  },
  [SET_RESET_QUOTE](state, payload) {
    return {
      ...state,
      costQuote: INIT_STATE.costQuote,
    };
  },
});

export const setFetching = (fetching) => ({
  type: SET_FETCHING,
  payload: fetching,
});

export const setData = (data) => ({
  type: SET_DATA,
  payload: data || INIT_STATE.data,
});

export const setError = (opened) => ({
  type: SET_ERROR,
  payload: opened,
});

export const setQuoteLoading = (loading) => ({
  type: SET_QUOTE_LOADING,
  payload: loading,
});

export const setQuote = (quote) => ({
  type: SET_QUOTE,
  payload: quote,
});

export const setResetQuote = (quote) => ({
  type: SET_RESET_QUOTE,
  payload: quote,
});
